export default "__VITE_ASSET__BEK7P4PS__"